import { connect } from 'react-redux';

import companyChargesActionCreators from '_store/_actions/charges';
import companyPaymentGatewaysActionCreators from '_store/_actions/companyPaymentGateways';

import ChargeForm from './ChargeForm';

const mapStateToProps = state => ({
  paymentGateways: state.companyPaymentGateways.paymentGateways,
  paymentMethods: state.companyPaymentGateways.paymentMethods,
  chargeStatus: state.companyPaymentGateways.chargeStatus,
  isEditing: state.companyCharges.isEditing,
  isCreating: state.companyCharges.isCreating,
  blockedPeriod: state.company.blockedPeriod,
  recipients: state.companyTransactions.recipients,
});

const mapDispatchToProps = {
  onEditCharge: companyChargesActionCreators.updateCharge,
  onCreateCharge: companyChargesActionCreators.createCharge,
  onDeleteCharge: companyChargesActionCreators.deleteCharge,
  onFetchCharges: companyChargesActionCreators.fetchCharges,
  onFetchCharge: companyChargesActionCreators.fetchChargeById,
  onFetchPaymentGateways: companyPaymentGatewaysActionCreators.fetchPaymentGateways,
  onFetchPaymentMethods:
    companyPaymentGatewaysActionCreators.fetchAvailablePaymentMethods,
  onFetchChargeStatus: companyPaymentGatewaysActionCreators.fetchAvailableChargeStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargeForm);
